<template>
  <v-card variant="outlined" class="metric-tile" >
    <v-card-title>
      <div class="d-flex justify-space-between align-center">
        Details
        <v-btn variant="text" @click="$emit('edit')">Edit</v-btn>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-title>
            {{ $t('common.title') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ title }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            {{ $t('common.slug') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ slug }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>
            {{ $t('common.entities.Tenant') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ tenant }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import {PropType} from "vue";
defineProps({
  title: {
    type: String as PropType<string>,
    required: true
  },
  slug: {
    type: String as PropType<string>,
  },
  tenant: {
    type: String as PropType<string>,
  }
});
</script>
